import { Tabs } from "antd";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "~/Hooks/useQuery";
import { Links } from "./Links/Links";
import { Overview } from "./Overview/OverView";

export const Milestones = () => {
  const navigate = useNavigate();
  const query = useQuery();

  const items = [
    {
      label: "Overview",
      key: "milestoneOverview",
      children: <Overview />,
    },
    {
      label: "Links",
      key: "milestoneLinks",
      children: <Links />,
    },
  ];

 
  return (
    <Tabs
      activeKey={query?.get("subActiveTab")|| items[0].key}
      items={items}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
  );
};
